import React from 'react';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const Feature = ({ background,title1, title, description1, description2, description3, img}) => {
  return (
    <section className="px-4 md:h-[600px] h-full sm:px-16 flex justify-center items-center" style={{ background }}>
      <div className={`flex flex-col justify-center  gap-6 p-6 md:p-10 md:flex-row-reverse`}>
      <div className='flex-shrink-0 max-w-full md:max-w-[50%]'>
      <LazyLoadImage
            src={img}
            className="md:h-[550px] md:w-[550px] object-cover rounded-2xl"
            alt=""
          />
        </div>
        <div className="flex flex-col gap-4 text-center md:text-left md:w-[50%] md:pt-7">
        <h2 className="text-lg " style={{ fontFamily: 'Poppins', color: '#262b33' }}>{title1}</h2>
          <h2 className="text-3xl font-semibold" style={{ fontFamily: 'Poppins', color: '#262b33' }}>{title}</h2>
          <p style={{ fontSize: '18px', fontFamily: 'Poppins', color: '#262b33' }}>{description1}</p>
          <p style={{ fontSize: '18px', fontFamily: 'Poppins', color: '#262b33' }}>{description2}</p>
          <p style={{ fontSize: '18px', fontFamily: 'Poppins', color: '#262b33' }}>{description3}</p>
        </div>
       
      </div>
    </section>
  );
};

Feature.propTypes = {
  background: PropTypes.string.isRequired,
  title1: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description1: PropTypes.string.isRequired,
  description2: PropTypes.string.isRequired,
  description3: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
};

export default Feature;
